module.exports = __webpack_public_path__ + "img/gestures_jp.c13c64b.jpg";